<template>
  <div v-if="attributesWithValues.length > 0" class="wdw-attribute-list">
    <div
      v-for="attribute in attributesWithValues"
      v-bind:key="attribute.id"
      class="thought-attribute badge badge-primary"
      :class="attributeClass(attribute)"
      role="listitem"
    >
      <div class="text-wrap text-start">
        <span>{{ attribute.name }}:&nbsp;</span>
        <span v-dompurify-html="getValue(attribute)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, computed } from 'vue';

export default {
  name: 'ThoughtAttributeTags',
  props: {
    attributes: {
      type: Array,
      required: true,
    },
  },

  setup(props) {
    const { attributes } = toRefs(props);
    const attributesWithValues = computed(() => {
      return attributes.value.filter(attr => {
        if (attr.value_all.length > 0) {
          return true;
        }
      });
    });

    function attributeClass(attribute) {
      return 'wdw-attribute-' + attribute.id + ' wdw-attribute-' + attribute.code;
    }

    function getValue(attribute) {
      if (attribute.value === null) {
        return '-';
      }
      return attribute.value_human;
    }

    return {
      attributesWithValues,
      attributeClass,
      getValue,
    };
  },
};
</script>

<style scoped>
.thought-attribute {
  display: flex;
  margin-right: 7px;
  margin-bottom: 5px;
  flex-wrap: wrap;
}
.wdw-attribute-list {
  margin-bottom: 5px;
  height: fit-content;
}
</style>
